import LocalTime from "local-time";

LocalTime.start();

document.addEventListener("turbo:morph", () => {
  LocalTime.run();
});
